import { httpGetRequest } from "clients/phronesisClient"
import {
	CUSTOMER_PROFILING_TABLE,
	CUSTOMER_PROFILING_CHART,
	CUSTOMER_PROFILING_INFORMATION,
	CUSTOMER_PROFILING_TIMELINE,
} from "constants/paths"

import { PARAMETER_KEYS } from "constants/parameters"
import { concatValues } from "helpers/service"
import { Tuple } from "components/Shared/Interfaces"
import { DataNode } from "components/Shared/Timeline/constants"
import { DateInterval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.utils"

const NUMBER_RETRIES = 0

interface FilterParameters {
	period: DateInterval
	filters: Record<string, Array<Tuple>>
	segment: string
	interval: string
	metric: string
}

export interface CustomerProfilingTable {
	id: string
	segment: string
	participation: number
	walmartParticipation: number
	customers: number
	sales: number
	purchaseFrequency: number
	spendByCustomer: number
	avgTicket: number
	itemsPurchased: number
	reach: number
}

export interface ChartTuple {
	id: string
	value: number
}
export interface CustomerProfilingChart {
	customerInformation: {
		totalCustomers: number
		percentageByCustomers: number
	}
	psychographics: Array<ChartTuple>
	age: Array<ChartTuple>
	gender: Array<ChartTuple>
}

export interface CustomerProfilingTimeline {
	interval: string
	metricName: string
	data: DataNode[]
}

export interface CustomerProfilingInformation {
	totalCustomers: number
	percentageByCustomers: number
}
export const getCustomerProfilingTableMetric = async (
	cancelToken: any,
	params: FilterParameters
): Promise<Array<CustomerProfilingTable>> => {
	const { segment } = params
	const parsedParams = prepareRequestParameters(params)

	const response = await httpGetRequest<Array<CustomerProfilingTable>>(
		CUSTOMER_PROFILING_TABLE + "/" + segment,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
	return response
}

export const getCustomerProfilingChartMetric = async (
	cancelToken: any,
	params: FilterParameters
): Promise<CustomerProfilingChart> => {
	const parsedParams = prepareRequestParameters(params)

	return await httpGetRequest<CustomerProfilingChart>(
		CUSTOMER_PROFILING_CHART,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
}

export const getCustomerProfilingInformation = async (
	cancelToken: any,
	params: FilterParameters
): Promise<CustomerProfilingInformation> => {
	const parsedParams = prepareRequestParameters(params)

	return await httpGetRequest<CustomerProfilingInformation>(
		CUSTOMER_PROFILING_INFORMATION,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
}

export const getCustomerProfilingTimelineMetric = async (
	cancelToken: any,
	params: FilterParameters
): Promise<CustomerProfilingTimeline> => {
	const parsedParams = prepareRequestParameters(params)

	return await httpGetRequest<CustomerProfilingTimeline>(
		CUSTOMER_PROFILING_TIMELINE,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
}

const prepareRequestParameters = (
	params: FilterParameters
): Record<string, string> => {
	const { period, filters, interval, metric, segment } = params
	const params_ = Object.keys(filters)
		.filter((key) => filters[key].length)
		.reduce(
			(currentValue, key) => ({
				...currentValue,
				[PARAMETER_KEYS[key]]: concatValues(filters[key]),
			}),
			{}
		)

	return { ...params_, ...period, interval, metricName: metric, segment }
}
